import PropTypes from 'prop-types';
import { ButtonContainer, DownloadPdfButton, LeadFormRedux, LeadRequestButton, PdfFormRedux } from './';

const ConversieButtons = ({
  app,
  settings,
  hidePdfButton,
  renderAs,
  PdfForm,
  LeadForm,
  handleSubmit,
  urlLeadFormParams,
  ...props
}) => {
  const { showLeadButton, enablePdf } = settings;

  return (
    <ButtonContainer {...props}>
      {enablePdf && !hidePdfButton && <DownloadPdfButton settings={settings} app={app} PdfForm={PdfForm} />}
      {showLeadButton && (
        <LeadRequestButton {...{ app, settings, LeadForm, renderAs, handleSubmit, urlLeadFormParams }} />
      )}
    </ButtonContainer>
  );
};

ConversieButtons.propTypes = {
  app: PropTypes.string.isRequired,
  settings: PropTypes.shape({}).isRequired,
  hidePdfButton: PropTypes.bool,
  handleSubmit: PropTypes.func,
  renderAs: PropTypes.oneOf(['PrimaryButton', 'PrimaryOutlineButton']),
  LeadForm: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  PdfForm: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

ConversieButtons.defaultProps = {
  hidePdfButton: false,
  handleSubmit: () => {},
  renderAs: 'PrimaryButton',
  LeadForm: LeadFormRedux,
  PdfForm: PdfFormRedux,
};

export default ConversieButtons;
